import { useMemo } from 'react';
import { assert, groupBySafe } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../base';
import { ReportInstanceDetailLoader } from './reportDetailInterface';
import { ReportInstanceDetailAggregate } from './reportDetailModel';

export function createReportDetailLoader(
    config: ReportingLoaderBaseConfig
): ReportInstanceDetailLoader {
    const { repository } = config;
    return {
        useLoad(context, props): ReportInstanceDetailAggregate {
            const reportQuery = repository.research.report.useLookup(
                context,
                { id: props.report.id },
                { suspense: true }
            );
            assert(reportQuery.status === 'success', 'expected suspense');
            const chapterQuery = repository.research.chapter.useFind(
                context,
                { report: props.report.id },
                { suspense: true }
            );
            const sourceQuery = repository.research.source.useFind(
                context,
                { stack: reportQuery.data.stack },
                { suspense: true }
            );
            const favoriteQuery = repository.research.favorite.useFind(
                context,
                { content: props.report.id },
                { suspense: true }
            );
            assert(chapterQuery.status === 'success', 'expected suspense');
            assert(sourceQuery.status === 'success', 'expected suspense');
            assert(favoriteQuery.status === 'success', 'expected suspense');
            const mentionQuery = repository.research.mention.useFind(
                context,
                { toIds: sourceQuery.data.map((item) => item.id) },
                { suspense: true }
            );
            assert(mentionQuery.status === 'success', 'expected suspense');
            const counts = useMemo((): ReportInstanceDetailAggregate['counts'] => {
                return {
                    interviews: sourceQuery.data.filter(
                        (source) => source.original.type === 'interview'
                    ).length,
                    goldstandard: sourceQuery.data.length,
                    scanned: 17203,
                };
            }, [sourceQuery.data]);

            const referencesByContent = useMemo(
                () => groupBySafe(mentionQuery.data, (item) => item.to),
                [mentionQuery.data]
            );

            const source = useMemo((): ReportInstanceDetailAggregate['source'] => {
                return {
                    items: sourceQuery.data.map((item) => ({
                        root: item,
                        mentions: referencesByContent[item.id] ?? [],
                    })),
                };
            }, [sourceQuery.data, referencesByContent]);

            return {
                report: reportQuery.data,
                chapters: chapterQuery.data,
                source,
                counts,
                favorite: favoriteQuery.data[0] ?? null,
                author: {
                    id: '1',
                    name: 'Agent Susie',
                },
            };
        },
    };
}
